import PhotoSwipeLightbox from 'photoswipe/dist/photoswipe-lightbox.esm.js';
import PhotoSwipe from 'photoswipe/dist/photoswipe.esm.js';

// if (document.querySelector('.js-photo-gallery')) {
    const lightbox = new PhotoSwipeLightbox({
        gallery: '.js-photo-gallery',
        children: 'a',
        pswpModule: PhotoSwipe
    });

    lightbox.init();

    const showAllBtn = document.querySelectorAll('.js-gallery-show-all');
    
    showAllBtn.forEach(btn => {
        btn.addEventListener('click', () => {
            btn.previousElementSibling.querySelectorAll('a')[0].click();
            console.log(btn.previousElementSibling);
        });
    });
// }